<!--
	作者：masonchen
	时间：2017-04-10
	描述：轨迹回放页面
-->
<template>
	<!--车辆监控页面_右侧tab面板之规划详情开始-->
	<div class="tab-bar">
		<div class="tab-row" >
			<div id="r-result" style="position: absolute; height: 100%;width: 300px; overflow: auto;"></div>
		</div>
	</div>
	<!--车辆监控页面_右侧tab面板之规划详情结束-->
</template>
<script>
	import {
		mapState
	} from 'vuex'

	export default {
		name: 'RoutePlanDetail',
		data() {
			return {

			}
		},
		computed: mapState({
		
		}),
		methods: {
			
		}

	}
</script>

<style>

</style>


// WEBPACK FOOTER //
// RoutePlanDetail.vue?73fddd34